import { borderRadius, shadows } from '@tempmee/tailwind';
import { EmptyScreen } from '../../commonComponents/EmptyScreen/EmptyScreen';

export const EmptyInbox = ({ Icon, title, description }) => (
  <figure
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      margin: 0,
      gap: 24,
      boxShadow: shadows['elevation-4'],
      borderRadius: borderRadius.pill,
      padding: '8px 0 64px',
    }}
  >
    <EmptyScreen
      Icon={Icon}
      title={title}
      description={description}
      descriptionStyle={{
        textAlign: 'center',
      }}
    />
  </figure>
);
